module.exports = __webpack_public_path__ + "media/images/icons/flags/IN-e9321da220bae91788ac3ef5639d93fd.svg";